import { parseBoolean, useGlobalContext } from '@honeycomb/data';
import { PaymentMethodsEnum } from '../../booking/utils/enums';
import { makeArrayFromConfig } from '../../booking/utils/makeArrayFromConfig';
// Determine if the PayPalPayInThree message should be diplayed.
export const useShowPayPalPayInThreeMessage = () => {
    const { configSettings: { HcSupportedPaymentTypes, PaypalEnablePayin3Messaging, HcPayPalPayLaterClientId }, } = useGlobalContext();
    const supportedPaymentTypes = makeArrayFromConfig(HcSupportedPaymentTypes);
    const paypalEnabled = supportedPaymentTypes === null || supportedPaymentTypes === void 0 ? void 0 : supportedPaymentTypes.includes(PaymentMethodsEnum.PAYPAL_V2);
    const payPalPayLaterEnabled = parseBoolean(PaypalEnablePayin3Messaging);
    return paypalEnabled && payPalPayLaterEnabled && HcPayPalPayLaterClientId.length >= 20;
};
